const Pact = require("../../entities/Pact");
const {Age}  = require("../Constants");
const PactNames = require("../Names/PactNames");


class LossOfSovereignty extends Pact {
    constructor() {
        super(
            Age.Age3,
            PactNames.LossOfSovereignty,
            "The two civilizations cannot attack each other. A produces an extra 2 culture per turn and B, 2 fewer culture. No one can declare war on civilization B.",
            {}
        )
    }
}

module.exports = LossOfSovereignty;